module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (state.showIcon) {
__p+='\n	<span class="vap-icon '+
((__t=( state.iconClassNames ))==null?'':_.escape(__t))+
'"></span>\n';
 } 
__p+='\n'+
((__t=( state.label ))==null?'':_.escape(__t))+
'';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/button/button.tpl
 ** module id = 88
 ** module chunks = 1 2 3 4 7 8 9 15 18 19 24 27 28 32 39 46 51 79 82 104 109 130 143 203
 **/